const privMap = new Map([
    [null, null],
    ['New', 'In Process'],
    ['Assigned', 'In Process'],
    ['In Process', 'In Process'],
    ['Pending', 'In Process'],
    ['Granted', 'Complete'],
    ['Temp Granted', 'Complete'],
    ['Cancelled', null],
    ['Verified', 'Complete'],
    ['Not Required', 'Complete'],
    ['Hold', 'In Process'],
    ['Expired', null],
]);

const assignmentStatusMap = new Map([
    ['Pre-Booked', 'assignments:STATUS.DATE_PENDING'],
    ['Booked', 'assignments:STATUS.UPCOMING'],
]);

export { assignmentStatusMap };
export default privMap;
